import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { JsonResult } from '../core/json-result.model';
import { Order } from '../models/virtual-store/order.model';
import { OrderInsertRequest } from '../models/virtual-store/order-insert-request.model';
import { EnvironmentService } from '../core/services/environment.service';
import { Ubigeo } from '../models/ubigeo.model';
import { OrderFnb } from '../models/virtual-store/orderFnb.model';
import { OrdenImpresionRequest, PagoMensualRequest } from '../models/virtual-store/order-Impresion';
import { OrderInsertResponse } from '../models/virtual-store/order-insert-response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  controller: string = 'Order';

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  list(clientCode: string) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('clientCode', clientCode);
    return this.httpClient.get<JsonResult<Order[]>>(url, { params: httpParams })
  }

  add(orderInsertRequest: OrderInsertRequest) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}`;
    //let url = `http://localhost:57954/api/Order`;
    return this.httpClient.post<JsonResult<string>>(url, orderInsertRequest)
  }
  addFNB(orderInsertRequest: OrderInsertRequest) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}`+'/InsertOrderToFNB'; 
    return this.httpClient.post<JsonResult<OrderInsertResponse>>(url, orderInsertRequest)
  }
  ContratoFNB(orderImpresionRequest: OrdenImpresionRequest) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}`+'/imprimirContrato';
    return this.httpClient.post(url, orderImpresionRequest,{ responseType: 'arraybuffer' });
  }
  getAllUbigeo() {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}`+'/GetAllUbigeo'; 
    return this.httpClient.get<JsonResult<Ubigeo[]>>(url)
  }
  listFnb(documentType: string, documentNumber: string) {
    let extraUrl=`${documentType}`+'/'+`${documentNumber}`
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}`+'/GetAllFinancingByClient/'+extraUrl;
    
    return this.httpClient.get<JsonResult<OrderFnb[]>>(url)
  }
}
